import React from 'react';

import { CustomRoute } from 'util/hook/useRouter';
import { appPath } from 'util/routingConfig';

const routes: CustomRoute = {
	path: appPath.adminBicycleFound.replace(appPath.admin, ''),
	components: () => [import(/* webpackChunkName: 'adminBicycleFound' */ './component')],
	render: ([AdminBicycleFound]) => <AdminBicycleFound />,
};

export default routes;
